export enum AutopilotAltitudeTypeEnum {
    None,
    wgs84,
    msl,
    agl
}

export enum AutopilotAltitudeUnitsEnum {
    None,
    meters,
    feet
}

export enum AutopilotAltitudeUnitsStringEnum {
    None = "None",
    meters = "meters",
    feet = "feet"
}